<template>
  <div class="order-manager">
    <div class="order-manager-search white-box">
      <div class="part">
        <span class="span-14">订单编号</span>
        <el-input class="search-input" v-model="filterTerm.orderNo" placeholder="请输入订单编号"></el-input>
      </div>
      <div class="part">
        <span class="span-14">商品名称</span>
        <el-input  class="search-input" v-model="filterTerm.commodityName" placeholder="请输入商品名称"></el-input>
      </div>
      <div class="part">
        <span class="span-14">商品类型</span>
        <el-select v-model="filterTerm.commodityType" placeholder="请选择">
          <el-option
            v-for="item in goodsTypeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="part">
        <span class="span-14">订单渠道</span>
        <el-select v-model="filterTerm.promotorId" placeholder="请选择">
          <el-option
            v-for="item in orderChannelOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="part">
        <span class="span-14">订单状态</span>
        <el-select v-model="filterTerm.orderStatus" placeholder="请选择">
          <el-option
            v-for="item in orderStatusOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="part">
        <span class="span-14">来源子站</span>
        <el-select v-model="filterTerm.sourceSubsiteId" placeholder="请选择">
          <el-option
            v-for="item in sourceStationOptions"
            :key="item.subSiteId"
            :label="item.subSiteName"
            :value="item.subSiteId">
          </el-option>
        </el-select>
      </div>
      <div class="part">
        <span class="span-14">用户昵称</span>
        <el-input class="search-input" v-model="filterTerm.buyerNickName" placeholder="请输入用户昵称"></el-input>
      </div>
      <div class="part">
        <span class="span-14">用户手机号</span>
        <el-input  class="search-input" v-model="filterTerm.buyerMobile" placeholder="请输入用户手机号"></el-input>
      </div>
      <div class="part choose-time">
        <span class="span-14">创建时间</span>
        <el-date-picker
          v-model="filterTerm.createdAtFrom"
          align="right"
          type="date"
          placeholder="选择起始日期">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filterTerm.createdAtTo"
          type="date"
          placeholder="选择终止日期">
        </el-date-picker>
      </div>
      <el-button :loading="loading" type="primary" icon="search" @click="handleSubmit">搜索</el-button>
      <a class="order-export" :href="`${PROTOCOL}${HOST}/orderMgmt/order/export?${requireData}`" target="_blank" download="订单.xlsx"><el-button>导出</el-button></a>
    </div>
    <div class="white-box order-manager-table">
      <p class="title">
        <span>订单列表</span>
        <span class="order-tips" @click="toOrderTips">佣金和分成比例不吻合？</span>
      </p>
      <table class="xmly-table">
        <thead>
            <tr>
                <th>商品名称</th>
                <th style="width: 100px;">商品类型</th>
                <th>用户</th>
                <th>订单金额（元）</th>
                <th>订单状态</th>
                <th>分成比例</th>
                <th>佣金（元）</th>
                <th>订单渠道</th>
                <th>来源</th>
                <th>创建时间</th>
            </tr>
        </thead>

        <tbody :key="order.orderNo" v-for="order in orderTableData">
            <tr class="order">
                <td>{{`订单编号：${order.orderNo}`}}</td>
            </tr>
            <tr>
                <td class="column-content">
                    <div class="pic">
                        <img :src="order.coverUrl">
                    </div>
                    <div class="info">
                        <h2 class="tit elli">{{order.commodityName}}</h2>
                        <p class="price elli">{{`售价：￥${order.commodityPrice}`}}</p>
                        <p class="count elli">{{`数量：${order.commodityAmount}`}}</p>
                    </div>
                </td>
                <td>{{order.commodityType}}</td>
                <td>
                    <p class="name elli">{{order.buyerNickName}}</p>
                    <p class="tel elli">{{order.buyerMobile}}</p>
                </td>
                <td>{{`￥${order.orderAmount}`}}</td>
                <td>{{order.orderStatus}}</td>
                <td>{{order.brokerageRatios}}</td>
                <td>{{`￥${order.brokerageAmount}`}}</td>
                <td>
                    <p class="elli">{{order.promotorType}}</p>
                    <p class="elli">{{order.promotorName}}</p>
                </td>
                <td>
                    <!-- <p class="elli">{{order.sourceSubsiteId}}</p> -->
                    <p class="elli">{{order.sourceSubsiteName}}</p>
                </td>
                <td>{{order.createdAt}}</td>
            </tr>
          </tbody>
        </table>
    </div>
    <div class="order-manager-pag column-content white-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="curPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="filterTerm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalRecords">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { deleteEmptyObj , getFormatTime } from 'utils'
  import { orderMgmtOrder, orderMgmtChannel, orderMgmtSubsite} from 'api'
    export default {
      data(){
        return {
          filterTerm: {
            "orderNo": "", // 订单编号
            "commodityType": "", // 商品类型
            "commodityName": "", // 商品名称
            "promotorId": "", // 分销商名称
            "buyerNickName": "", // 用户昵称
            "buyerMobile": "", // 用户手机号
            "orderStatus": "", // 订单状态
            "sourceSubsiteId": "", // 子站Id
            "createdAtFrom": "", // 创建时间区间起始时间
            "createdAtTo": "", // 创建时间区间结束时间
            "pageNo": "", // 页码
            "pageSize": 20, // 分页大小
          },
          curPage: 1,
          totalRecords: 0,
          loading:false,
          goodsTypeOptions:[
            {
              id:0,
              name:'全部'
            },
            {
              id:1,
              name:'单集购买'
            },
            {
              id:2,
              name:'付费订阅'
            },
            {
              id:4,
              name:'巅峰会员'
            },
          ],
          orderChannelOptions:[],
          orderStatusOptions:[
            {
              id:0,
              name:'全部'
            },
            {
              id:2,
              name:'订单成功'
            },
            {
              id:5,
              name:'已退款'
            }
          ],
          sourceStationOptions:[],
          orderTableData:[]
        }
      },
      components:{

      },
      computed: {
        ...mapGetters([
          'HOST',
          'PROTOCOL',
          'promotorType'
        ]),
        requireData:function(){
          let vis = this
          let temp = deleteEmptyObj(vis.getSendData())
          let result = ''
          for(let i in temp){
            const value = temp[i]
            result = `${result}&${i}=${value}`
          }
          return result.substr(1)
        }
      },
      created(){
        let vis = this
        if(this.$route.query.number) {
          this.$data.filterTerm.orderNo = this.$route.query.number
        }
        orderMgmtChannel().then(res=>{
          if(res && res.ret==0){
            vis.orderChannelOptions = res.data
            vis.orderChannelOptions.unshift({id:0,name:'全部'})
          }
        }).catch(()=>{})
        orderMgmtSubsite().then(res=>{
          if(res && res.ret==0){
            vis.sourceStationOptions = res.data
            vis.sourceStationOptions.unshift({subSiteId:0,subSiteName:'全部'})
          }
        }).catch(()=>{})
        vis.handleSubmit()
      },
      methods:{
        handleSizeChange(){
          this.filterTerm.pageSize = arguments[0];
          this.handleSubmit()
        },
        toOrderTips () {
          let _url =  this.promotorType == '2' ? 'https://shimo.im/docs/WTtmdBMOjqAyRkgY/' : 'https://shimo.im/docs/Z8BPssACvkMPXyzF/'
          window.open(_url, '_blank')
        },
        handleCurrentChange(){
          this.curPage = arguments[0];
          this.handleSubmit()
        },
        getSendData(){
          let vis = this

          let temp = JSON.parse(JSON.stringify(vis.filterTerm))
          temp['curPage'] = vis.curPage;

          const createdAtFrom = vis.filterTerm.createdAtFrom
          const createdAtTo = vis.filterTerm.createdAtTo
          if(createdAtFrom || createdAtTo){
            temp.createdAtFrom = createdAtFrom && vis.filterTerm.createdAtFrom.getTime()
            temp.createdAtTo = createdAtTo && vis.filterTerm.createdAtTo.getTime()+(23*3600+59*60+59)*1000
            if(createdAtFrom && createdAtTo && temp.createdAtFrom>=temp.createdAtTo){
              vis.$message({
                message:'终止日期需大于起始日期，请重新选择',
                type:'warning'
              })
              vis.filterTerm.createdAtFrom = ''
              vis.filterTerm.createdAtTo = ''
              return
            }
          }
          return temp
        },
        handleSubmit(){
          let vis = this
          vis.loading = true
          orderMgmtOrder(deleteEmptyObj(vis.getSendData())).then(res=>{
            vis.loading = false
            if(res.ret==0){
              const resData = res.data
              const orders = vis.handleOrderData(resData.orders)
              vis.orderTableData = orders
              vis.totalRecords = resData.totalRecords
              // vis.curPage = resData.curPage
            }
          }).catch(()=>{})
        },
        handleOrderData(data){
          if(data){
            data.map(item=>{
              for(let i in item){
                if(i=='orderStatus'){
                  item[i]= item[i] == 5 ? '已退款' : (item[i] == 2 ? '订单成功' : '')
                }else if(i=='commodityType'){
                  item[i] = item[i] == 1 ? '单集购买' : (item[i] == 2 ? '付费订阅': '巅峰会员')
                }else if(i=='promotorType'){
                  if(item[i] == 1) {
                    item[i] = '城市服务商'
                  }else if(item[i] == 2) {
                    this.promotorType == 1 ? item[i] = '分销商': item[i] = ''
                  }else {
                    item[i] = ''
                  }
                }else if(i=='createdAt'){
                  item[i] = getFormatTime(item[i])
                }
              }
            })
          }else{
            data = []
          }
          return data
        }
      }
    }
</script>

<style lang="scss" scoped>
.order-manager{
  &>div{
    width: 1100px;
  }
  div.part{
    display: inline-block;
  }
  .el-input__icon+.el-input__inner{
    padding-right:26px;
  }

  .choose-time{
    margin-right: 20px;
  }
  .el-button--primary{
    margin-left: 0px;
    margin-right: 20px;
  }
  .order-manager-search{
    padding:20px;
    height: 235px;
    line-height: 50px;
    .el-input,.el-select{
      margin:0 55px 0 0px;
      width:200px;
    }
    .el-date-editor{
      width:130px;
      margin-right: 0px;
      margin-left: 0px;
    }

    span.span-14{
      display: inline-block;
      width: 75px;
      text-align: left;
    }
  }
  .order-manager-table{
    margin-top: 10px;
    .title{
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #333333;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      border-bottom:1px solid #e8e8e8;
    }
  }
  .order-manager-pag{
    margin-top: 10px;
    height: 74px;
  }
}
.order-tips {
  font-size: 14px;
  color: #4990E2;
  cursor: pointer;
  float: right;
  margin-right: 15px;
}


table{
     border:none;
     border-collapse: collapse;
     border-spacing: 0;
 }
 .xmly-table{
     background:#fff;
 }
 .xmly-table thead tr{
     font-size: 14px;
     color:#999;
     background:#fff;
     border-bottom: 10px solid #fafafa;
 }
 .xmly-table thead th{
     font-weight: normal;
     padding:10px 20px;
 }


 .xmly-table tbody tr{
     margin-top:10px;
     font-size:14px;
     color:#666;
     background:#fff;
     border-bottom:10px solid #fafafa;
     text-align: center;
 }
  .xmly-table tbody tr:last-child{
      border-bottom:none;
  }
 .xmly-table tbody tr td{
     padding:15px 10px 8px;
 }
 .xmly-table tbody .order{
    border-bottom:none;
    white-space: nowrap;
 }
.xmly-table tbody .order td{
     padding:10px 20px 0;
     font-size: 12px;
     color: #666;
 }
 .xmly-table tbody .order td:before{
     content:'';
     display: inline-block;
     width: 3px;
     height: 14px;
     background: #f86442;
     vertical-align: bottom;
     margin-right:8px;
 }
 .xmly-table tbody tr td .elli{
     max-width: 100px;
 }
 .xmly-table .pic{
     width:50px;
     height:50px;
     display: inline-block;
     margin-right:5px;
 }
 .xmly-table .pic img{
      width:100%;
      height:100%;
  }
 .xmly-table .info{
     display: inline-block;
     text-align: left;
 }
 .xmly-table .info .elli{
     max-width: 200px;
 }
 .xmly-table .info .tit{
    margin:0;
     font-size:12px;
     color:#333;
 }

 .elli{
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     vertical-align: middle;
 }
</style>





// WEBPACK FOOTER //
// index.vue?97987d8e